export default [
    {
        path: "/bidding/approve-deviation",
        name: "approve-deviation",
        meta: {
            title: "Approve Deviation",
            authRequired: true,
            privileges: []},
        component: () => import("../views/bidding/approve-deviation.vue"),
    }
]